import ShortcutsModal from './ShortcutsModal.container'

export default ShortcutsModal
